import { Component, OnInit } from '@angular/core'
import { MatProgressBar } from '@angular/material/progress-bar'
import { PaginationComponent } from '../../shared/components/pagination/pagination.component'
import { TableListComponent } from '../../shared/components/table-list/table-list.component'
import { AuthService } from '../../core/services/auth/auth.service'
import { MatDialog } from '@angular/material/dialog'
import {
  PagedContactTypeResponse,
  SearchContactTypeModel,
} from '../../core/models/contact-type.model'
import { FormSearchComponent } from '../../shared/components/form-search/form-search.component'
import { MatButton } from '@angular/material/button'
import { MatPaginatorModule } from '@angular/material/paginator'
import { PageEvent } from '@angular/material/paginator'
import {MatCard} from '@angular/material/card';
import {ExamTypeCreateComponent} from '../../features/exam-type/document-type-create/exam-type-create.component';
import {MatIcon} from '@angular/material/icon';
import {SnackbarCustomService} from '../../shared/components/snackbar/snackbar-custom.service';
import {ContextService} from '../../core/services/context/context.service';
import {ContextCreateComponent} from '../../features/context/context-create/context-create-component';
import {ContextEditComponent} from '../../features/context/context-edit/context-edit-component';

@Component({
  selector: 'context',
  imports: [
    MatProgressBar,
    TableListComponent,
    MatPaginatorModule,
    MatCard,
    ContextCreateComponent,
  ],
  templateUrl: './context.component.html',
  styleUrl: './context.component.scss',
  providers: [ContextService, AuthService],
  standalone: true,
})
export class ContextComponent implements OnInit {
  constructor(
    private alertService: ContextService,
    private authService: AuthService,
    private dialog: MatDialog,
    private snackbar: SnackbarCustomService,
  ) {}

  page: number = 1
  rows: number = 10
  numberRows: number = 0
  itemsList: any[] = []
  loading: boolean = false
  searchForm: SearchContactTypeModel = new SearchContactTypeModel()
  inputSearch: string = ''
  columns: any[] = [
    {
      keyColumn: 'id',
      key: 'id',
      description: 'Código',
    },
    {
      keyColumn: 'nome',
      key: 'nome',
      description: 'Nome',
    },
    {
      keyColumn: 'descricao',
      key: 'descricao',
      description: 'Descrição',
    },
    {
      keyColumn: 'action',
      key: { edit: true, delete: true },
      description: 'Ações',
    },
  ]
  screen: string = 'contexto'

  ngOnInit() {
    this.checkColumnAction()
    this.getListItems()
  }

  checkColumnAction() {
    let index = this.columns.findIndex((ele: any) => {
      return ele.keyColumn == 'action'
    })
    if (index != -1) {
      this.columns[index].key = {
        edit: this.checkPermission('editar'),
        delete: this.checkPermission('excluir'),
      }
      if (!Object.values(this.columns[index].key).includes(true)) {
        this.columns.splice(index, 1)
      }
    }
  }

  checkPermission(permission: string) {
    return this.authService.checkPermission(permission, this.screen)
  }

  search(event: any) {
    let search = event
    this.page = 1
    if (search) {
      this.searchForm.descricao = search
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  pageChanged(page: number) {
    this.page = page
    this.uploadList()
  }

  onPageEvent(event: PageEvent) {
    this.page = event.pageIndex + 1 // pageIndex é zero-based, a sua variável page é 1-based
    this.rows = event.pageSize
    this.uploadList()
  }

  pageSizeChanged(newPageSize: number) {
    this.rows = newPageSize
    this.page = 1 // normalmente reseta para a primeira página
    this.uploadList()
  }

  uploadList(type: string = '') {
    if (type == 'new') {
      this.searchForm = new SearchContactTypeModel()
    }
    if (this.searchForm.descricao) {
      this.searchListItems()
    } else {
      this.getListItems()
    }
  }

  treatResponse(response: any) {
    let list = []
    if (response.data) {
      for (let item of response.data) {
        list.push(item)
      }
    }
    this.itemsList = list
    this.numberRows = response.totalItens
  }

  // getListItems() {
  //   this.loading = true
  //   this.locationService.listPagedLocation(this.page, this.rows).subscribe({
  //     next: (response: any) => {
  //       this.treatResponse(response)
  //     },
  //     error: (err: PagedContactTypeResponse) => {},
  //     complete: () => {
  //       this.loading = false
  //     },
  //   })
  // }
  getListItems() {
    this.loading = true
    this.alertService.listContext().subscribe({
      next: (response: any) => {
        this.treatResponse(response)
      },
      error: (err: PagedContactTypeResponse) => {},
      complete: () => {
        this.loading = false
      },
    })
  }

  searchListItems() {
    this.loading = true
    this.alertService
      .searchPagedAdmin(this.page, this.rows, this.searchForm)
      .subscribe({
        next: (response: any) => {
          this.treatResponse(response)
        },
        error: (err: PagedContactTypeResponse) => {},
        complete: () => {
          this.loading = false
        },
      })
  }


  editItem(item: any) {
    console.log(item, 'item')
    const dialogRef = this.dialog.open(ContextEditComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '950px',
      // height: '100vh',
      data: item,
    })
    dialogRef.componentInstance.responseEdit.subscribe((response) => {
      this.uploadList()
    })
  }

  deleteItem(item: any) {
    this.alertService.deleteContext(item.id).subscribe({
      next: (response: any) => {
        console.log(response.data)
        this.snackbar.success(response.message)
      },
      error: (erro: any) => {
        this.snackbar.error(erro.message)
      },
      complete: () => {
        this.getListItems()
      }
    })
  }
}
